import { useEffect, useState } from 'react';
import { Button, Modal, Form, Spinner } from 'react-bootstrap';
import { Input } from 'Components/Common/Form';
import { Brokers } from 'Services';
import { convertIntoTitleCase } from 'Utils';
import { useSelector } from 'react-redux';

// Validation
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './validation';

export default ({ selectedBroker, handleConnectedCredentials, ...props }) => {
  const [properties, setProperties] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state) => state.auth.user);

  const { avatar_url: brokerLogo, name, id, pdf_url: pdfUrl } = selectedBroker;

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const propsData = { ...values };
      delete propsData.label;

      await Brokers.connectPortfolio(
        id,
        {
          label: values.label,
          values: propsData,
        },
        user.id,
      );

      resetForm();
      handleConnectedCredentials();
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const getProperties = async () => {
      setIsLoading(true);
      try {
        const { keys } = await Brokers.getProperties(id, user.id);
        setProperties(keys);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    if (id) getProperties();
  }, [id, user.id]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues(properties),
    onSubmit: handleSubmit,
    validationSchema: validationSchema(properties),
  });

  return (
    <Modal size="md" centered className="broker-credentials-modal" animation={false} {...props}>
      <Modal.Header closeButton>
        <Modal.Title />
      </Modal.Header>
      <Modal.Body>
        <div className="broker-details">
          <img src={brokerLogo} alt="logo" className="logo" />
          <h4 className="title">{name}</h4>
        </div>

        <div className="color-white mt-3">
          <div>Connect Broker</div>
          <b>Enter your credentials</b>
        </div>

        <div>
          for a step by step walkthrough, click{' '}
          {pdfUrl ? (
            <a href={pdfUrl || '#'} target="_blank" rel="noreferrer">
              {'<here>'}
            </a>
          ) : (
            '<here>'
          )}{' '}
          links to a step-by-step process with photos
        </div>

        {isLoading ? (
          <div>
            <Spinner animation="border" size="lg" className="mt-5" />
          </div>
        ) : (
          <Form onSubmit={formik.handleSubmit}>
            <Input label="Nickname *" type="text" placeholder="Enter broker nickname" {...formik.getFieldProps('label')} />
            {formik.touched.label && formik.errors.label ? <div className="form-error">{formik.errors.label}</div> : null}

            {properties.map((value) => (
              <div key={value}>
                <Input
                  label={`${convertIntoTitleCase(value.replace(/_/g, ' '))} *`}
                  placeholder={`Enter your ${convertIntoTitleCase(value.replace(/_/g, ' '))}`}
                  type="text"
                  name={value}
                  {...formik.getFieldProps(value)}
                />
                {formik.touched[value] && formik.errors[value] ? <div className="form-error">{formik.errors[value]}</div> : null}
              </div>
            ))}

            <div className="text-center">
              <Button className="mt-2" type="submit" disabled={formik.isSubmitting}>
                Connect Now {formik.isSubmitting && <Spinner animation="border" size="sm" className="ml-2" />}
              </Button>
            </div>
          </Form>
        )}
      </Modal.Body>
    </Modal>
  );
};
